/* eslint-disable */
import React from 'react';
import { ThemeContext } from './ThemeProviderWithFonts';
import { ErrorReporting } from '../base/errorHandling/ErrorReporting';
import { baseUnit } from '../theming/baseUnitDefinition';

type MapThemeProps<T> = (theme: T) => T;

export const useTheme = <T extends object>(mapThemeProps: MapThemeProps<T>, key?: string): T => {
  const reporter = React.useContext(ErrorReporting);
  const themeContext = React.useContext(ThemeContext);

  if (key && themeContext[key] || !key) {
    const mapObject = {
      ...(key && themeContext[key]),
      fontSizesStyles: themeContext.fontSizesStyles,
      baseUnit,
    };
    return mapThemeProps(mapObject);
  }

  reporter.reportWarning(`cannot find key: ${key} in configuration`);
  return {} as T;
};
